import React from "react"
import {Card, Dropdown, Menu, Tooltip} from "antd";
import {DownloadOutlined} from "@ant-design/icons";
import DownloadRequestsService, {
    DOWNLOAD_REQUEST_FORMAT,
    DOWNLOAD_REQUEST_FORMAT_LABELS,
    DOWNLOAD_REQUEST_TYPES
} from "../../../../model/service/export/DownloadRequestsService";
import IViewUnit from "../../../../model/interface/dataStorage/IViewUnit";
import IRestServiceOptions from "../../../../model/interface/api/IRestServiceOptions";
import IViewSettingsStructure from "../../../../model/interface/dataStorage/view/settings/IViewSettingsStructure";
import Button from "../../../shared/button/Button";
import {IAppState} from "../../../../redux/store";
import {connect} from "react-redux";
import selectors from "../../../../redux/selectors";
import LocaleText from "../../settings/dictionary/LocaleText";

interface IProps {
    viewUnit: IViewUnit
    totalCount: number
    options: IRestServiceOptions
    settings: IViewSettingsStructure,
    type?: string,
    getText: (code: string, fallBack?: string) => string
}

interface IState {
    loading: boolean
}


class ViewTableExportButton extends React.Component<IProps, IState> {


    constructor(props: IProps, context: any) {
        super(props, context);
        this.state = {
            loading: false
        }
    }

    export(format: string) {
        const {viewUnit, totalCount, options, settings, type, getText} = this.props
        this.setState({loading: true})
        DownloadRequestsService.create(
            type || DOWNLOAD_REQUEST_TYPES.DATA_STORAGE_VIEW,
            format,
            getText(viewUnit.label),
            {
                uuid: viewUnit.uuid,
                parameters: options,
                settings: settings
            }).then(resource => {
            DownloadRequestsService.prepareModal(resource, getText)

            this.setState({loading: false})
            DownloadRequestsService.prepareDownload(resource, totalCount, getText);
        }).catch(() => this.setState({loading: false}))
    }

    render() {
        const {loading} = this.state
        const {totalCount, viewUnit, getText} = this.props

        let formats: string[] = []
        if (!viewUnit.options.exportFormats?.length) {
            formats.push(DOWNLOAD_REQUEST_FORMAT.XLSX)
        } else {
            formats = viewUnit.options.exportFormats
        }

        return (
            <div className={"d-inline-block"}>
                {formats.length > 1 ? (
                    <Tooltip title={<LocaleText code={'configuration.view.export-button.tooltip'} fallback={"Exportovat data"}/>}>
                        <Dropdown disabled={totalCount === 0} trigger={['click']} overlay={
                            <Card size={"small"}>
                                <Menu>
                                    {formats.map(format => (
                                        <Menu.Item className={'m-0'} onClick={() => this.export(format)} key={format}
                                                   icon={DOWNLOAD_REQUEST_FORMAT_LABELS.find(f => f.value === format)?.icon}>
                                            {DOWNLOAD_REQUEST_FORMAT_LABELS.find(f => f.value === format)?.label}
                                        </Menu.Item>
                                    ))}
                                </Menu>
                            </Card>
                        }>
                            <Button
                                disabled={totalCount === 0}
                                loading={loading}
                                icon={<DownloadOutlined/>}
                                size={"small"}
                            ></Button>
                        </Dropdown>
                    </Tooltip>
                ) : (
                    <Tooltip
                        title={getText('configuration.view.export-button.format-tooltip','Exportovat do formátu') + ' ' + DOWNLOAD_REQUEST_FORMAT_LABELS.find(f => f.value === formats[0])?.label}>
                        <Button
                            disabled={totalCount === 0}
                            loading={loading}
                            onClick={() => this.export(formats[0])}
                            icon={<DownloadOutlined/>}
                            size={"small"}
                        />
                    </Tooltip>
                )}
            </div>
        )
    }
}

const mapStateToProps = (state: IAppState) => {
    return {
        getText: (code: string, fallback?: string) => selectors.dictionary.getMessage(state, code, fallback)
    }
}

export default connect(mapStateToProps)(ViewTableExportButton)
